import Model, { ID, Integer } from 'src/models/model'
import Archivable from 'src/models/model/concerns/Archivable'

export default class MarketingSubscription extends Model {
  static name = 'MarketingSubscription'

  static isConfiguration = true

  static versioned = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Marketing]

  static define () {
    this.concerns = [Archivable]

    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      siteId: {
        type: ID,
        required: true,
        output: true
      },
      siteName: {
        type: String,
        required: true,
        output: true
      },
      displayOrder: {
        type: Integer,
        default: 9999,
        required: true
      },
      channelEmail: {
        type: Boolean,
        default: true
      },
      channelPush: {
        type: Boolean,
        default: false
      },
      channelSms: {
        type: Boolean,
        default: false
      },
      excludeFromRegistration: {
        type: Boolean,
        default: false
      }
    }
  }

  hasChannelEnabled (channel) {
    switch (channel) {
      case 'email':
        return this.channelEmail
      case 'push':
        return this.channelPush
      case 'sms':
        return this.channelSms
      default:
        return false
    }
  }
}
